<template>
    <div>
        <el-row :gutter="30">
            <el-col class="box" :span="24">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="file" label="url"/>
                    <el-table-column width="180" label="data">
                        <template slot-scope="scope" class="pull-right">
                            {{ formatDate(scope.row.timestamp) }}
                        </template>
                    </el-table-column>
                    <!--<el-table-column label="akcje" width="150" class="pull-right">-->
                    <!--<template slot-scope="scope" class="pull-right">-->
                    <!--<el-button type="danger"-->
                    <!--size="small"-->
                    <!--:title="$t('delete')"-->
                    <!--@click="handleDelete(scope.$index, scope.row)"><i-->
                    <!--class="el-icon-delete"></i>-->
                    <!--</el-button>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                </el-table>
                <el-col :span="24" class="list__pagination">
                    <el-pagination layout="prev, pager, next"
                                   @current-change="handlePageChange"
                                   :page-size="pageSize" :total="count">
                    </el-pagination>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import ListFilterComponent from '@/components/ListFilterComponent'
    import {Attachment} from '@/api'
    import moment from 'moment'

    export default {
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                data: [],
                count: 0,
                page: 1,
                pageSize: 100,
                listLoading: false,
                service: Attachment
            }
        },
        methods: {
            formatDate (value) {
                if (value) {
                    return moment(String(value)).format('MM/DD/YYYY hh:mm:ss')
                }
            },
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.data = response.data.results;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        mounted () {
            this.fetchData();
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// AttachmentsList.vue?b5432b94